export default [
    {
        path: 'relatorio-atendimento-diario',
        component: () => import(
            /* webpackChunkName: 'farmacia-relatorio-atendimento-diario' */
            '@/views/farmacia/relatorio-atendimento-diario/Index'
        ),
        redirect: 'relatorio-atendimento-diario/index',
        children: [
            {
                name: 'farmacia-relatorio-atendimento-diario-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'farmacia-relatorio-atendimento-diario' */
                    '@/views/farmacia/relatorio-atendimento-diario/List'
                ),
            },
        ]
    }
]